import { combineReducers } from 'redux';
import registrationReducer from './modules/registration';
import titleFeesReducer from './modules/titlefees';
import salesTaxesReducer from './modules/salestaxes';
import mobileHomeReducer from './modules/mobilehome';
import otherTransactionFeesReducer from './modules/otherTransactionFees';

const reducers = combineReducers({
  registration: registrationReducer,
  titlefees: titleFeesReducer,
  salestaxes: salesTaxesReducer,
  mobilehome: mobileHomeReducer,
  otherTransactionFees: otherTransactionFeesReducer,
});

export default reducers;
